<template>
  <div>
    <header-page
      :namePage="$t('pagesTitles.schedule')"
      :links="$store.state.headerLinks.mimkMcLinks"
    />

    <div class="content">
      <SalaryModal ref="salaryModal" />
      <v-select
        v-if="userRole === 'admin'"
        class="select-mimk"
        :options="$store.state.user.mimkList"
        :loading="!$store.state.user.mimkListLoaded"
        :placeholder="$t('mc.placeholders.selectMimkFromList')"
        :clearable="false"
        @input="setMimk"
      />
      <v-select
        v-if="$store.state.user.segmentsList"
        :options="$store.state.user.segmentsList"
        :clearable="false"
        :searchable="false"
        label="title"
        class="select-mimk"
        @input="changeSegment"
        v-model="currentSegment"
      >
        <template #selected-option="{ title }">
          {{ title }}
        </template>
        <template #option="{ title }">
          {{ title }}
        </template>
      </v-select>
      <div class="day-container">
        <loader v-if="isLoader" />
        <template v-else>
          <span class="day-container-segment"
            >{{ segmentInfo.timezone_name }}: {{ localTime }}</span
          >
          <div class="timetable__week-change">
            <span class="timetable__week-toggler" @click="changeWeek()">{{
              $t("mc.supervisor.week.weeks.prev")
            }}</span>
            <h2 class="timetable__week_title">
              {{ $t("mc.supervisor.week.weeks.current") }}: {{ currentWeek }}
            </h2>
            <span class="timetable__week-toggler" @click="changeWeek(true)">{{
              $t("mc.supervisor.week.weeks.next")
            }}</span>
          </div>
          <div v-for="(day, indexDay) in workDays" :key="indexDay">
            <div class="day">
              <div class="day__name">{{ day.name_translated }}</div>
              <div class="day__iswork" v-if="day.is_work">
                <div class="day-times">
                  <div
                    class="day-time_box"
                    :class="time.is_admin_hours ? '' : 'day-time_box--not-admin'"
                    v-for="(time, indexTime) in day.work_hours"
                    :key="indexTime"
                  >
                    <span v-if="time.is_admin_hours" class="day-time_box__type">{{ localesTypeOfHour[time.type_of_hours] }}</span>
                    {{ time.work_starts_at }} – {{ time.work_ends_at }}
                  </div>
                </div>
              </div>
              <div class="day-time_box day-time_off" v-else>
                {{ $t("mc.supervisor.week.dayoff") }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import militaryAndLanguage from "@/helpers/militaryAndLanguage";
import apiWorkWeeks from "@/api/master-classes/workWeeks";
import apiBooking from "@/api/master-classes/booking";
import SalaryModal from "@/components/Mimk/Modals/SalaryModal";
export default {
  data() {
    return {
      militaryAndLanguage,
      isLoader: true,
      currentSegment: "",
      currentWeekDays: {
        firstday: "",
        lastday: "",
      },
      workDays: [],
      formatLocale: null,
      formatedTime: null,
      localTime: "",
      localesTypeOfHour: {},
    };
  },
  components: {
    SalaryModal,
  },
  async created() {
    this.fetchHourTypes()
    try {
      this.$metrika.reachGoal("TCM_click_schedule_tab");
    } catch (err) {
      console.log(err);
    }
    this.currentSegment = this.$store.state.user.segment;
    this.userId = this.$store.state.user.user.id;
    //Форммируем даты для расписания 1 и последнего дня текущей недели
    this.currentWeekDays.firstday = this.$dayjs()
      .isoWeekday(1)
      .format("YYYY-MM-DD");
    this.currentWeekDays.lastday = this.$dayjs()
      .isoWeekday(7)
      .format("YYYY-MM-DD");
    // if (this.$dayjs.locale() === 'ru' || this.$dayjs.locale() === 'tr' || this.$dayjs.locale() === 'es' || this.$dayjs.locale() === 'id') {
    //   this.currentWeekDays.firstday = this.$dayjs().weekday(0).format('YYYY-MM-DD')
    //   this.currentWeekDays.lastday = this.$dayjs().weekday(0).add(6, 'day').format('YYYY-MM-DD')
    // }
    // if (this.$dayjs.locale() === 'en') {
    //   this.currentWeekDays.firstday = this.$dayjs().weekday(1).format('YYYY-MM-DD')
    //   this.currentWeekDays.lastday = this.$dayjs().weekday(1).add(6, 'day').format('YYYY-MM-DD')
    // }
    //Вызываем метод для получения данных на текущую неделю
    await this.changeSegment();
    setInterval(this.timeRun, 1000);
    this.isLoader = false;
  },
  destroyed() {
    clearInterval(this.timeRun);
  },
  computed: {
    currentWeek() {
      return `${this.$dayjs(this.currentWeekDays.firstday).format(
        "DD.MM"
      )} - ${this.$dayjs(this.currentWeekDays.lastday).format("DD.MM.YYYY")}`;
    },
    userRole() {
      return this.$store.state.user.user.role;
    },
  },
  methods: {
    fetchHourTypes() {
      apiWorkWeeks.getWorkHoursTypes().then(types => {
        types = types.filter(item => item.key !== 'Проведение уроков')
        const localeObject = {}
        types.forEach(type => { localeObject[type.key] = type.translated_type })
        this.localesTypeOfHour = localeObject

      })
    },
    receiveTimeFromat(isMilitaryTime, hour, acceptedParam) {
      let formatHour = "";
      isMilitaryTime ? (formatHour = "HH:mm") : (formatHour = "hh:mm a");
      return {
        formatedTime: this.$dayjs(hour, acceptedParam).format(formatHour),
        formatDependForLocale: formatHour,
      };
    },
    timeRun() {
      this.localTime = this.$dayjs(this.localTime, this.formatLocale).add(
        1,
        "second"
      );
      this.localTime = this.$dayjs(this.localTime).format(this.formatLocale);
    },
    async changeSegment() {
      this.segmentInfo = await apiBooking.getSegmentInfo(
        this.currentSegment.title
      );
      console.log(this.segmentInfo);
      await this.getTimeslotData();
      this.formatedTime = this.receiveTimeFromat(
        this.segmentInfo.military_time,
        this.segmentInfo.segment_local_time
      ).formatedTime;
      this.formatLocale = this.receiveTimeFromat(
        this.segmentInfo.military_time,
        this.segmentInfo.segment_local_time
      ).formatDependForLocale;
      this.localTime = this.formatedTime;
    },
    openSalaryModal() {
      this.$refs.salaryModal.openModal();
    },
    async getTimeslotData() {
      let isMilitaryTime = this.militaryAndLanguage();
      this.isLoader = true;
      //Запрос на получение данных по ID МИМКа и выбранному периоду
      const data = await apiWorkWeeks.getWorkWeeks(
        this.userId,
        this.currentWeekDays.firstday,
        this.currentWeekDays.lastday,
        this.currentSegment.id
      );
      //Присваиваем рабочие дни в this.workDays
      this.workDays = data.work_week;
      // Меняем рабочие часы в удобный формат для вывода на пользователю
      this.workDays.forEach((element) => {
        for (let hours in element.work_hours) {
          let hour = element.work_hours[hours];
          hour.work_ends_at = isMilitaryTime
            ? hour.work_ends_at.split(" ")[1]
            : this.$dayjs(hour.work_ends_at.split(" ")[1], "HH:mm").format(
                "hh:mm a"
              );
          hour.work_starts_at = isMilitaryTime
            ? hour.work_starts_at.split(" ")[1]
            : this.$dayjs(hour.work_starts_at.split(" ")[1], "HH:mm").format(
                "hh:mm a"
              );
        }
      });
      this.isLoader = false;
    },
    //Метод вызываемый при выборе предыдущей или следующей недели
    async changeWeek(isNext) {
      //Если пользователь выбирает следующую неделю передаем параметр isNext Далее в зависимости от параметра вычитаемили прибавляем дни
      if (isNext) {
        this.currentWeekDays.firstday = this.$dayjs(
          this.currentWeekDays.firstday
        )
          .add(7, "day")
          .format("YYYY-MM-DD");
        this.currentWeekDays.lastday = this.$dayjs(
          this.currentWeekDays.firstday
        )
          .add(6, "day")
          .format("YYYY-MM-DD");
      } else {
        this.currentWeekDays.firstday = this.$dayjs(
          this.currentWeekDays.firstday
        )
          .subtract(7, "day")
          .format("YYYY-MM-DD");
        this.currentWeekDays.lastday = this.$dayjs(this.currentWeekDays.lastday)
          .subtract(7, "day")
          .format("YYYY-MM-DD");
      }
      this.isLoader = true;
      //Получаем расписание на выбранную неделю
      await this.getTimeslotData();
      this.isLoader = false;
    },
    //Данный функционал доступен только админу, при появлении селекта и выбора конкретного мимка, для просмотра его распиания
    async setMimk(mimk) {
      this.userId = mimk.id;
      this.$store.commit("user/setAdminSharedMimkId", mimk.id);
      await this.getTimeslotData();
    },
  },
};
</script>

<style lang="scss" scoped>
.day {
  margin-left: 50px;
  &-container {
    padding: 48px 25px 85px 25px;
    background: #fff;
    &-segment {
      display: block;
      text-align: center;
      margin-bottom: 20px;
      font-weight: bold;
      font-size: 17px;
      color: #485270;
    }
  }
  margin-bottom: 24px;
  display: grid;
  align-items: center;
  grid-template-columns: 155px 120px 120px;
  column-gap: 20px;
  margin-bottom: 20px;
  &-time {
    &_box {
      &--not-admin {
        border: 1px solid #315AF2;
        color: #315AF2;
      }
      &__type {
        position: absolute;
        top: 0;
        font-size: 10px;
      }
      position: relative;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 18px;
      max-width: 150px;
      min-width: 150px;
      padding: 15px 0;
      font-size: 14px;
      border: 1px solid #c9c9c9;
      cursor: pointer;
      border-radius: 4px;
      font-family: "Open Sans", sans-serif;
      margin-bottom: 5px;
      &:last-child {
        margin-right: 0;
      }
    }
    &_off {
      background: #f1f1f5;
    }
  }
  &__name {
    font-weight: 500;
    font-size: 16px;
    text-align: left;
  }
  &-times {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

.timetable {
  &__week {
    &-change {
      margin-bottom: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &-toggler {
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      color: #315af2;
    }
    &_title {
      font-weight: 700;
      font-size: 18px;
    }
  }
}
</style>
